<template>
  <b-modal id="modal-import-result" v-model="visible" size="md" :title="title" centered>
    <div class="text-center mb-4">
      <div class="text-center">
        <p style="text-align: center">
          <strong>Số bản ghi thành công:</strong>
          {{ countSuccess || 0 }}
        </p>
        <p style="text-align: center">
          <strong>Số bản ghi thất bại:</strong>
          {{ countFaild || 0 }}
        </p>
      </div>
      <button
        v-if="countFaild"
        style="font-weight: 400"
        class="btn btn-outline-danger mt-2"
        @click="downloadErrorFile"
      >
        Tải bản ghi thất bại
      </button>
    </div>

    <template #modal-footer>
      <button class="btn btn-primary" @click="visible = false">OK</button>
    </template>
  </b-modal>
</template>
<script>
  import { showMess } from '@/config/utils'
  // import { DeviceService } from '@/services/device.service'
  export default {
    data() {
      return {
        visible: false,
        title: 'Nhập file thành công',
        countSuccess: 0,
        countFaild: 0,
        errors: [],
        func: () => {},
        classService: null,
      }
    },
    methods: {
      closeModal() {
        this.visible = false
      },
      openModal(countSuccess, countFaild, errors, func, classService) {
        this.countSuccess = countSuccess
        this.countFaild = countFaild
        this.errors = errors
        this.func = func
        this.classService = classService
        this.visible = true
      },
      async downloadErrorFile() {
        try {
          await this.func.bind(this.classService)(this.errors)
        } catch (error) {
          showMess(
            this,
            'Error',
            error.response?.data?.message || error.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            3000
          )
        } finally {
          this.visible = false
        }
      },
    },
  }
</script>
